import { Input, inject, Output, EventEmitter } from '@angular/core';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {
  AlertStore,
  EAlertModes,
  EAlertTypes,
  IAlertItem,
} from '@alert/data-access';
import { ButtonComponent } from '@shared/components/ui/button';

@Component({
  selector: 'lib-toast',
  templateUrl: './toast.component.html',
  imports: [CommonModule, TranslateModule, ButtonComponent],
})
export class ToastComponent {
  public readonly alertStore = inject(AlertStore);
  @Input() alertItem: IAlertItem;
  @Output() close = new EventEmitter<IAlertItem>();
  public alertTypes = EAlertTypes;
  public alertModes = EAlertModes;

  public animationEnd(): void {
    this.close.emit(this.alertItem);
  }

  public actionButton(): void {
    if (this.alertItem.actionButton) {
      this.alertItem.actionButton();
      this.close.emit(this.alertItem);
    }
  }
}
